<template>
  <q-dialog
    :visible="isVisible"
    :title="title"
    width="68%"
    :innerScroll="false"
    @close="onCancel"
    :loading="loadingBth"
    @cancel="onCancel"
    @confirm="onConfirm"
  >
    <div class="content">
      <el-form ref="addForm" :model="addForm" :rules="dynamicRules" label-width="100px" v-loading="loading">
        <div class="section-header">SKU查询</div>
        <div class="sku-query">
          <el-form-item label="SKU编码" prop="skuCode">
            <el-input v-model="addForm.skuCode" size="mini" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="SKU名称" prop="skuName">
            <el-input v-model.trim="addForm.skuName" size="mini" placeholder="请输入"></el-input>
          </el-form-item>
          <div class="sku-query-btn">
            <el-button type="primary" size="mini" @click="onSearch">搜索</el-button>
            <el-button type="warning" size="mini" @click="onReset">重置</el-button>
          </div>
        </div>
        <!-- SPU设置部分 -->
        <div class="section-header">SPU设置</div>
        <div class="spu-info">
          <div class="info-item">
            <span class="label">SPU编码：</span>
            <el-tooltip :content="addForm.spuCode" placement="top" :disabled="!addForm.spuCode">
              <span class="value orange-text code-ellipsis">{{ addForm.spuCode }}</span>
            </el-tooltip>
          </div>
          <div class="info-item">
            <span class="label">SPU名称：</span>
            <el-tooltip :content="addForm.spuName" placement="top" :disabled="!addForm.spuName">
              <span class="value orange-text code-ellipsis">{{ addForm.spuName }}</span>
            </el-tooltip>
          </div>
        </div>

        <el-row>
          <el-col :span="12">
            <el-form-item label="可放类目" prop="category">
              <el-input v-model.trim="addForm.category" size="mini" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="上架类型" prop="upType">
              <el-radio-group v-model="addForm.upType">
                <el-radio label="1">需上架</el-radio>
                <el-radio label="2">同以前</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="上架时间" prop="shelfTime">
              <el-date-picker
                v-model="addForm.shelfTime"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="请选择"
                size="mini"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item label="上架店铺" prop="storeCodes">
          <el-checkbox-group v-model="addForm.storeCodes">
            <template v-if="storeList && storeList.length">
              <el-checkbox v-for="item in storeList" :label="item.storeCode" :key="item.storeCode">{{ item.shortName }}</el-checkbox>
            </template>
          </el-checkbox-group>
        </el-form-item>

        <!-- 商品信息部分 -->
        <div v-for="(product, index) in addForm.itemAOS" :key="product.skuCode">
          <div class="section-header">商品{{ index + 1 }}</div>
          <div class="product-header">
            <div class="product-info">
              <div class="info-item">
                <span class="label">商品编码：</span>
                <el-tooltip :content="product.skuCode" placement="top" :disabled="!product.skuCode">
                  <span class="value orange-text code-ellipsis">{{ product.skuCode }}</span>
                </el-tooltip>
              </div>
              <div class="info-item">
                <span class="label">商品名称：</span>
                <el-tooltip :content="product.goodsName" placement="top" :disabled="!product.goodsName">
                  <span class="value orange-text text-ellipsis">{{ product.goodsName }}</span>
                </el-tooltip>
              </div>
            </div>
            <!-- 修改批量复制部分 -->
            <div class="batch-copy">
              <!-- <span style="margin-right: 5px">批量复制</span>
              <el-select v-model="product.selectedProductIndex" placeholder="请选择需要复制商品编码" size="mini" style="width: 200px">
                <el-option v-for="(item, idx) in addForm.itemAOS" :key="item.skuCode" :label="`商品${idx + 1}: ${item.goodsName}`" :value="item.skuCode"></el-option>
                <el-option
                  v-for="(item, idx) in addForm.itemAOS"
                  :key="idx"
                  :label="`商品${idx + 1}: ${item.goodsName.substring(0, 10)}...`"
                  :value="idx"
                ></el-option> -->
              <!-- </el-select>
              <el-button type="primary" size="mini" class="copy-btn" @click="handleBatchCopy(product.selectedProductIndex)">批量复制</el-button>-->
              <el-button type="primary" size="mini" class="copy-btn" @click="copyToAll(index)" v-if="addForm.itemAOS.length > 1">批量填充</el-button>
            </div>
          </div>

          <el-row>
            <el-col :span="12">
              <el-form-item label="搜索关键词" :prop="'itemAOS.' + index + '.searchWords'">
                <el-input v-model.trim="product.searchWords" size="mini" placeholder="请输入"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="是否松木" :prop="'itemAOS.' + index + '.pine'">
                <el-radio-group v-model="product.pine">
                  <el-radio :label="1">是</el-radio>
                  <el-radio :label="0">否</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <el-form-item label="生产进度" :prop="'itemAOS.' + index + '.produceProgress'">
                <el-select v-model="product.produceProgress" placeholder="请选择" size="mini">
                  <el-option v-for="item in produceProgressList" :key="item.confValue" :label="item.confName" :value="item.confValue"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-form-item label="备注" :prop="'itemAOS.' + index + '.remark'">
            <el-input v-model.trim="product.remark" type="textarea" :rows="2" size="mini" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="质保通栏" :prop="'itemAOS.' + index + '.warrantyInfo'">
            <el-input v-model.trim="product.warrantyInfo" type="textarea" :rows="2" size="mini" placeholder="请输入"></el-input>
          </el-form-item>
        </div>
      </el-form>
    </div>
  </q-dialog>
</template>

<script>
import axios from '@/utils/axiosInstance';
export default {
  name: 'BasicInfoEdit',
  props: {
    // 重新对外暴露visible，控制显示隐藏
    visible: {
      type: Boolean,
      default: false,
    },
    // 编辑的行数据
    rowData: {
      type: Object,
      default: () => ({}),
    },
    editList: {
      type: Array,
      default: () => [],
    },
    type: Number,
    listNo: [Number, String],
  },
  computed: {
    // 通过计算属性，对.sync进行转换，外部也可以直接使用visible.sync
    isVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
      },
    },
    title() {
      return '基础信息编辑';
    },
    // 动态生成校验规则
    dynamicRules() {
      const rules = {
        // category: [{ required: false, message: '请输入可放类目', trigger: 'blur' }],
        // upType: [{ required: true, message: '请选择上架类型', trigger: 'change' }],
      };

      // 为每个商品项添加校验规则
      if (this.addForm.itemAOS && this.addForm.itemAOS.length) {
        this.addForm.itemAOS.forEach((_, index) => {
          rules[`itemAOS.${index}.pine`] = [{ required: true, message: '请选择是否松木', trigger: 'change' }];
          rules[`itemAOS.${index}.produceProgress`] = [{ required: true, message: '请选择生产进度', trigger: 'change' }];
        });
      }

      return rules;
    },
  },
  data() {
    return {
      loading: false,
      loadingBth: false,
      addForm: {
        spuCode: '',
        spuName: '',
        skuCode: '',
        skuName: '',
        category: '',
        upType: '1',
        storeCodes: [],
        shelfTime: '',
        itemAOS: [],
      },
      rules: {},
      storeList: [],
      produceProgressList: [],
      currencyForm: {
        pageSize: 999999,
        pageNum: 1,
        reportCode: '',
        param: {},
        queryMatch: [],
        orderList: [],
        orderType: '',
        hasCount: 'N',
        groupAttr: '',
      },
    };
  },
  created() {
    this.$set(this.addForm, 'skuCode', this.rowData.skuCode);
    this.$set(this.addForm, 'skuName', this.rowData.goodsName);
    this.$set(this.addForm, 'shelfTime', this.rowData.shelfTime);
    this.getStoreList();
    this.getSendCycleList();
    this.initFormData();
  },
  methods: {
    onCancel() {
      this.isVisible = false;
    },
    onConfirm() {
      // this.$refs.addForm.validate((valid) => {
      // if (!valid) return;
      this.loadingBth = true;
      const saveData = {
        listNo: this.listNo,
        type: this.type,
        ...this.addForm,
        storeCode: this.addForm.storeCodes,
        itemAOS: this.addForm.itemAOS.map(item => {
          const cleaned = { ...item };
          delete cleaned.sendCycle;
          delete cleaned.deliveryCycle;
          return cleaned;
        }),
      };
      this.$q.newProduct
        .productListBaseEdit({ data: saveData })
        .then((res) => {
          if (res.success) {
            this.$message.success(`保存成功`);
            this.isVisible = false;
            this.$emit('success');
          } else {
            this.$notify.error({
              message: res.message || '保存失败',
              duration: 0,
            });
          }
        })
        .finally((_) => {
          this.loadingBth = false;
        });
      // });
    },

    onSearch() {
      this.initFormData();
    },
    onReset() {
      this.addForm.skuCode = '';
      this.addForm.skuName = '';
      this.initFormData();
    },

    // 初始化表单数据
    initFormData() {
      this.loading = true;
      let data = {
        listNo: this.listNo,
        spuCode: this.rowData.spuCode,
        skuCode: this.addForm.skuCode,
        skuName: this.addForm.skuName,
      };
      this.$q.newProduct
        .productListGetDetail({ data: data })
        .then((res) => {
          this.addForm = {
            ...this.addForm,
            ...res.data,
            skuCode: this.addForm.skuCode,
            skuName: this.addForm.skuName,
            storeCodes: res.data.storeCodes || [],
          };
        })
        .finally(() => {
          this.loading = false;
        });
    },

    // 批量复制处理
    handleBatchCopy(command) {
      // command是选中的商品索引
      if (command !== undefined && command !== null && command !== '') {
        let list = this.addForm.itemAOS.map((v) => v.skuCode);

        const sourceIndex = list.indexOf(command);
        const sourceProduct = this.addForm.itemAOS[sourceIndex];

        this.$confirm(`确定要将商品${sourceIndex + 1}的信息复制到其他所有商品吗?`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            // 复制到所有其他商品
            this.addForm.itemAOS.forEach((product, index) => {
              if (index !== sourceIndex) {
                // 复制除了商品编码和名称以外的所有信息
                product.searchWords = sourceProduct.searchWords;
                product.pine = sourceProduct.pine;
                product.produceProgress = sourceProduct.produceProgress;
                product.remark = sourceProduct.remark;
                product.warrantyInfo = sourceProduct.warrantyInfo;
              }
            });

            this.$message.success('批量填充成功');
            // 清空所有商品的selectedProductIndex
            this.addForm.itemAOS.forEach((product) => {
              product.selectedProductIndex = '';
            });
          })
          .catch(() => {
            // 取消操作
          });
      } else {
        this.$message.warning('请先选择要复制的商品');
      }
    },

    // 从当前商品复制到所有其他商品
    copyToAll(currentIndex) {
      const sourceProduct = this.addForm.itemAOS[currentIndex];

      this.$confirm(`确定要将当前商品的信息填充到其他所有商品吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          // 复制到所有其他商品
          this.addForm.itemAOS.forEach((product, index) => {
            if (index !== currentIndex) {
              // 复制除了商品编码和名称以外的所有信息
              product.searchWords = sourceProduct.searchWords;
              product.pine = sourceProduct.pine;
              product.produceProgress = sourceProduct.produceProgress;
              product.remark = sourceProduct.remark;
              product.warrantyInfo = sourceProduct.warrantyInfo;
            }
          });

          this.$message.success('批量填充成功');
          // 清空所有商品的selectedProductIndex
          this.addForm.itemAOS.forEach((product) => {
            product.selectedProductIndex = '';
          });
        })
        .catch(() => {
          // 取消操作
        });
    },

    getStoreList() {
      let data = {
        pageNum: 1,
        pageSize: 999999,
        filterData: {
          newArrival: 1,
        },
      };
      this.searchFormData = data;
    this.$q.configurationCenter
      .storeManagePage({ data: data })
      .then((res) => {
        if (res.code == 200) {
          this.storeList = res.data.list;
        }
      })
    },
    getSendCycleList() {
      let data = { ...this.currencyForm };
      data.reportCode = 'sendCycle';
      axios.post(`/ec-pc-api/custom/reports/data/sendCycle`, data).then((res) => {
        if (res.code == 200) {
          this.produceProgressList = res.data.list.filter((v) => v.categoryCode == 'produceProgress');
        }
      });
    },
  },
};
</script>

<style lang="stylus" scoped>
>>> .el-input--mini .el-input__inner, >>> .el-date-editor.el-input, >>> .el-date-editor.el-input__inner {
  width: 200px !important;
}

>>> .el-input {
  width: 200px !important;
}

>>> .el-textarea {
  width: 100% !important;
}

.content {
  padding-right: 15px;
  max-height: 65vh;
  overflow-y: auto;
}

.section-header {
  font-weight: bold;
  border-bottom: 1px solid #DCDFE6;
  padding: 5px 0 15px 0;
  font-size: 16px;
  margin: 15px 0;
}

.sku-query {
  display: flex;
  justify-content: space-between;
}

.sku-query-btn {
  margin-top: 10px;
}

.spu-info, .product-header .product-info {
  display: flex;


  .info-item {
    margin-right: 30px;

    .label {
      font-weight: bold;
      margin-right: 5px;
    }

    .orange-text {
      color: #FF8C00;
    }
  }
}

.spu-info {
  margin-bottom: 15px
}

.product-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;

  .batch-copy {
    .copy-btn {
      margin-left: 10px;
    }
  }
}

>>> .dialog-content {
  padding-right: 0 !important;
  padding-left: 15px !important;
}

>>> .el-dialog {
  margin-top: 50px !important;
}

::-webkit-scrollbar {
  width: 6px;
}

::-webkit-scrollbar-thumb {
  height: 45.7326%;
  transform: translateY(0%);
  position: relative;
  display: block;
  cursor: pointer;
  border-radius: inherit;
  border-radius: 10px;
  background-color: rgba(144, 147, 153, 0.3);
  transition: 0.3s background-color;
}

.code-ellipsis {
  display: inline-block
  width: 200px
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: bottom;
  @media screen and (min-width: 1920px) {
    width: 15vw !important;
  }
}

.text-ellipsis {
  max-width: 300px;
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: bottom;
  @media screen and (min-width: 1920px) {
    max-width: 50vw !important;
  }
}
</style>
